const Marionette = require('lib/marionette')
const Element = require('../model/element.base')


const InputRadiosetView = Marionette.CollectionView.extend({

    displayName: 'InputRadiosetView',

    tagName: 'fieldset',

    childView() {
        // circular dependency
        const ElementView = require('./element_view')
        return ElementView
    },

     
    constructor: function constructor(options) {
        // validate model
        if (! (options.model instanceof Element)) throw new Error('InputView requires an Element model.')

        options.collection = options.model.get('values')

        Marionette.CollectionView.call(this, options)

        // listen for external changes to the model
        this.listenTo(this.model, 'change:value', this.onModelChangeValue)

        // these steps allow the view to consume an existing dom element
        this.listenTo(this, 'render', this.setAttributes)
        const className = this.model.get('className')
        if (className) this.$el.addClass(className)

    },

})

module.exports = InputRadiosetView
